"use strict";
import * as Bluebird from "bluebird";
var templateUrl = require("../../views/directives/voicemailPlayer.html");
var directivesModule = require("directives/directivesModule");
import VoicemailPlayer from "../asset/voicemailPlayer";
import blobService from "../services/blobService";
import Progress from "../asset/Progress";
var ProgressBar = require('progressbar.js');
var loadVoicemail = function (voicemail) {
    var loadProgress = new Progress();
    voicemail.loading = true;
    voicemail.getProgress = function () { return loadProgress.getProgress(); };
    return blobService.getBlobUrl(voicemail.blobID, voicemail.type, voicemail.size, loadProgress).then(function (url) {
        voicemail.url = url;
        voicemail.loading = false;
        voicemail.loaded = true;
        return voicemail;
    });
};
var voicemailPlayerComponent = /** @class */ (function () {
    function voicemailPlayerComponent($element) {
        var _this = this;
        this.$element = $element;
        this.startTime = 0;
        this.seekVal = 0;
        this.toggle = function () { return _this.isPlaying() ? _this.pause() : _this.play(); };
        this.isPlaying = function () { return _this.player ? _this.player.isPlaying() : false; };
        this.isLoading = function () { return !!_this.voicemails.find(function (_a) {
            var loading = _a.loading;
            return loading;
        }); };
        this.getProgress = function () { return _this.voicemails.reduce(function (prev, _a) {
            var getProgress = _a.getProgress;
            return getProgress ? prev + getProgress() : 0;
        }, 0); };
        this.getSize = function () { return _this.voicemails.reduce(function (prev, _a) {
            var size = _a.size;
            return prev + size;
        }, 0); };
        this.isLoaded = function () { return _this.voicemails.reduce(function (prev, _a) {
            var loaded = _a.loaded;
            return prev && loaded;
        }, true); };
        this.timeUpdate = function (position) {
            var time = Math.floor(position);
            _this.progress.set(position / _this.getDuration());
            if (_this.previousTime === time) {
                return;
            }
            _this.previousTime = time;
            _this.$element.find("#position").text(_this.formatPosition(time));
        };
        this.formatPosition = function (position) {
            var minutes = Math.floor(position / 60);
            var seconds = position % 60;
            var minutesString = ("0" + minutes).substr(-2);
            var secondsString = ("0" + seconds).substr(-2);
            return minutesString + ":" + secondsString;
        };
        this.seekTo = function (position) {
            if (_this.player) {
                return _this.player.seekTo(position);
            }
            _this.startTime = position;
            _this.timeUpdate(position);
        };
        this.loadAndPlay = function () {
            var voicemails = _this.voicemails;
            return Bluebird.resolve(voicemails)
                .map(function (voicemail) { return loadVoicemail(voicemail); })
                .map(function (_a) {
                var url = _a.url, duration = _a.duration;
                return ({ url: url, estimatedDuration: duration });
            })
                .then(function (voicemails) { return new VoicemailPlayer(voicemails); })
                .then(function (player) {
                _this.player = player;
                _this.player.onPositionUpdateRAF(_this.timeUpdate);
                _this.player.awaitLoading().then(function () {
                    _this.player.seekTo(_this.startTime);
                    _this.player.play();
                });
            });
        };
        this.play = function () { return _this.player ? _this.player.play() : _this.loadAndPlay(); };
        this.pause = function () { return _this.player.pause(); };
        this.getDuration = function () { return _this.player ? _this.player.getDuration() : _this.voicemails.reduce(function (prev, _a) {
            var duration = _a.duration;
            return prev + duration;
        }, 0); };
        this.$postLink = function () {
            var progressElement = _this.$element.find(".voicemail--progress")[0];
            _this.progress = new ProgressBar.Line(progressElement, {
                strokeWidth: 2,
                trailWidth: 2,
                svgStyle: { width: '100%', height: '25%' }
            });
            progressElement.addEventListener('click', function (event) {
                var rect = progressElement.getBoundingClientRect();
                var progress = (event.pageX - rect.left) / rect.width;
                _this.seekTo(_this.getDuration() * progress);
            });
        };
    }
    voicemailPlayerComponent.$inject = ["$element"];
    return voicemailPlayerComponent;
}());
directivesModule.component("voicemailPlayer", {
    bindings: {
        voicemails: "<"
    },
    templateUrl: templateUrl,
    controller: voicemailPlayerComponent
});



//////////////////
// WEBPACK FOOTER
// ./js/directives/voicemailPlayer.ts
// module id = null
// module chunks = 